import { useState, useCallback, useEffect, useRef } from "react";
import { TextField } from "@mui/material";
import useDebouncedEffect from "$hooks/useDebounceEffect";

type DebounceProps = {
  value?: string;
  onChange: (value: any) => void;
  debounceTimeout?: number;
  type?: string;
  className?: string;
  placeholder?: string;
};

function JDebounceInput({
  value,
  onChange,
  debounceTimeout = 300,
  type = "text",
  ...rest
}: DebounceProps) {
  // Normalize undefined from filters to "" so controlled TextField never gets null/undefined
  // and so localValue !== value does not thrash ("" vs undefined).
  const normalizedValue = value ?? "";
  const [localValue, setLocalValue] = useState(normalizedValue);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    setLocalValue(normalizedValue);
  }, [normalizedValue]);

  useDebouncedEffect(
    () => {
      if (localValue !== normalizedValue) {
        onChangeRef.current(localValue);
      }
    },
    [localValue, normalizedValue],
    debounceTimeout
  );

  const handleInputChange = useCallback((e: any) => {
    setLocalValue(e.target.value);
  }, []);

  return (
    <TextField
      type={type}
      value={localValue}
      onChange={handleInputChange}
      {...rest}
      variant="outlined"
    />
  );
}

export default JDebounceInput;
